export const frenchMonthsMap = {
  Jan: 'janv.',
  Feb: 'févr.',
  Mar: 'mars',
  Apr: 'avrl',
  May: 'mai',
  Jun: 'juin',
  Jul: 'juil.',
  Aug: 'août',
  Sep: 'sept.',
  Oct: 'oct.',
  Nov: 'nov.',
  Dec: 'déc.'
};
